export const notesMigrationTypes = {
  SET_NOTES_MIGRATION_FILTERS: 'SET_NOTES_MIGRATION_FILTERS',
  GET_NOTES_MIGRATION: 'GET_NOTES_MIGRATION',
  SELECT_NOTE_TO_MIGRATE: 'SELECT_NOTE_TO_MIGRATE',
  REMOVE_NOTES_SELECTION: 'REMOVE_NOTES_SELECTION',
  DESELECT_NOTE_TO_MIGRATE: 'DESELECT_NOTE_TO_MIGRATE',
  ERROR_NOTES_MIGRATION: 'ERROR_NOTES_MIGRATION',
  DO_NOTES_MIGRATION: 'DO_NOTES_MIGRATION',
  CLEAR_NOTES_MIGRATION: 'CLEAR_NOTES_MIGRATION',
  SET_CONFIG_FILTER_NOTES_MIGRATION: 'SET_CONFIG_FILTER_NOTES_MIGRATION',
  SET_CONFIG_PAGE_NOTES_MIGRATION: 'SET_CONFIG_PAGE_NOTES_MIGRATION',
  SET_CONFIG_PAGE_SIZE_NOTES_MIGRATION: 'SET_CONFIG_PAGE_SIZE_NOTES_MIGRATION',
  SET_CONFIG_SORTED_NOTES_MIGRATION: 'SET_CONFIG_SORTED_NOTES_MIGRATION',
  UPDATE_NOTE_MIGRATION:'UPDATE_NOTE_MIGRATION',
  TOGGLE_FIVE_PER_THOUSAND: 'TOGGLE_FIVE_PER_THOUSAND',
}